const Input = ({
  input,
  validatorHint,
  icon,
  children,
  label,
  suffix,
  isTouched,
  isError,
  className,
}: {
  input: "input" | "textarea";
  validatorHint: React.ReactNode;
  icon: React.ReactNode;

  children: React.ReactNode;
  label?: string;
  suffix?: string;
  isTouched: boolean;
  isError: boolean;
  className?: string;
}) => {
  return (
    <div className="group">
      <label
        className={`${input} ${(isError ? "input-error has-focus:input-warning" : className) || (isTouched && "input-success")} floating-label w-full transition-colors duration-250 mb-0.5 shadow-lg`}
      >
        <div className="label">{icon}</div>
        {children}
        <span className="rounded-full">{label}</span>
        {suffix && <kbd className="badge kbd-lg">{suffix}</kbd>}
      </label>
      <p
        className={`${isError && "text-error group-focus-within:text-warning mb-0.5"}`}
      >
        {validatorHint}
        {!isError && <br />}
      </p>
    </div>
  );
};
export default Input;
